module.exports = __webpack_public_path__ + "img/instagram_icon.c0b16a07.svg";